const typeCollectionBanner = document.querySelectorAll(
  ".type__collection-banner"
);
const typeCollectionBannerTitle = document.querySelectorAll(
  ".type__collection-banner-title"
);

typeCollectionBannerTitle.forEach((title) => {
  const collectionBannerType = title.getAttribute(
    "data-collection-banner-type"
  );

  title.addEventListener("click", function () {
    typeCollectionBannerTitle.forEach((title) => {
      title.classList.remove("active");
    });
    typeCollectionBanner.forEach((banner) => {
      const bannerType = banner.getAttribute("data-type");

      if (collectionBannerType === bannerType) {
        banner.classList.add("active");
      } else {
        banner.classList.remove("active");
      }
    });

    title.classList.add("active");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Get all scrollContainers and buttons
  const scrollContainers = document.querySelectorAll("#scrollContainer");
  const prevBtns = document.querySelectorAll(".prevBtn");
  const nextBtns = document.querySelectorAll(".nextBtn");

  // Loop through each scrollContainer and its corresponding buttons
  scrollContainers.forEach((scrollContainer, index) => {
    const prevBtn = prevBtns[index]; // Corresponding prev button
    const nextBtn = nextBtns[index]; // Corresponding next button

    // Scroll to the next item
    nextBtn.addEventListener("click", () => {
      scrollContainer.scrollBy({
        left: scrollContainer.offsetWidth, // Scroll the width of one item
        behavior: "smooth",
      });
    });

    // Scroll to the previous item
    prevBtn.addEventListener("click", () => {
      scrollContainer.scrollBy({
        left: -scrollContainer.offsetWidth, // Scroll backwards the width of one item
        behavior: "smooth",
      });
    });

    // Optional: Implement logic to hide arrows when at the start or end of scroll (if needed)
    function updateArrowVisibility() {
      const maxScrollLeft =
        scrollContainer.scrollWidth - scrollContainer.clientWidth;

      // prevBtn.style.display = scrollContainer.scrollLeft <= 0 ? 'none' : 'block';
      // nextBtn.style.display = scrollContainer.scrollLeft >= maxScrollLeft ? 'none' : 'block';
    }

    scrollContainer.addEventListener("scroll", updateArrowVisibility);

    // Initial check
    updateArrowVisibility();
  });
});
